
import React from 'react';
import ClassScheduleManager from "@/components/schedule/ClassScheduleManager";

interface ScheduleTabProps {
  organizationId: string;
  initialClassId: string;
}

const ScheduleTab: React.FC<ScheduleTabProps> = ({
  organizationId,
  initialClassId
}) => {
  return (
    <div className="pt-4">
      <ClassScheduleManager 
        organizationId={organizationId} 
        initialClassId={initialClassId} 
      />
    </div>
  );
};

export default ScheduleTab;
